<template lang="pug">
  .garbage
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :endpointExport="getExportPoint"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      :actionColumnWidth="100"
    )
    router-view
</template>

<script>
import { garbage, export_document } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'

export default {
  mixins: [tableMixin],
  watch: {
    $route: 'onRoute',
  },
  methods: {
    onRoute(newVal) {
      return this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getEndpoint(newVal),
      })
    },
    getEndpoint(route) {
      return garbage.garbages({
        ...route,
        query: { ...route.query, group_code: route.meta.group },
      })
    },
    getExportPoint() {
      return export_document.garbageGroup({
        ...this.$route,
        query: { ...this.$route.query, group_code: this.$route.meta.group },
      })
    },
    getDeleteUrl(id) {
      return garbage.garbageDelete(id)
    },
    editItem({ id }) {
      this.$router.push({
        name: `garbage.${this.$route.meta.group}.update`,
        params: { id: id },
      })
    },
  },
}
</script>
